/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const paymentMethodService = {
  getList: (params: any) =>
    request.get('/legal-entity-payment-method', { params }),
  getPaymentMethodById: (id: any) =>
    request.get(`/legal-entity-payment-method/${id}`),
  createPaymentMethod: (data: any) =>
    request.post('/legal-entity-payment-method', data),
  deletePaymentMethod: (id: any) =>
    request.delete(`/legal-entity-payment-method/${id}`),
  updatePaymentMethod: (id: any, data: any) =>
    request.put(`/legal-entity-payment-method/${id}`, data)
};

export default paymentMethodService;
